import 'babel-polyfill';

import Vue from 'vue';
import './styles/styles.scss';

import './plugins/buefy.plugin';
import './plugins/logdown.plugin';
import './plugins/formatter.plugin';
import './plugins/axios.plugin';
import './plugins/vuex.plugin';
import './plugins/event-bus.plugin';
import './plugins/clipboard.plugin';
import { i18n } from './plugins/i18n.plugin';
import './plugins/vuelidate.plugin';

import App from './app/App.vue';
import { router } from './router';
import { store } from './app/store';
import { appConfig } from './config/app.config';
import '@baloise/design-system-components/dist/design-system-components/design-system-components.css';
import { defineCustomElements } from '@baloise/design-system-components/loader';
import googleAnalyticsService from '@/app/mixins/GoogleAnalyticsService';

Vue.config.productionTip = false;

defineCustomElements();

googleAnalyticsService.init();
googleAnalyticsService.initIntegrations();

const vueInstance = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
});

export const useI18nInstance = vueInstance.$i18n;

const log = Vue.$createLogger('main');

log.info(`The environment is ${appConfig.env}.`);
log.info(`The apiPath is ${appConfig.apiPath}.`);
log.info(`The basePath is ${appConfig.basePath}.`);
log.info(`The routerDisableRefreshRerouting is ${appConfig.routerDisableRefreshRerouting}.`);

Vue.config.ignoredElements = ['bal-app', 'bal-navbar', 'bal-navbar-brand', 'bal-footer'];
vueInstance.$mount('#app');

